import { DollarSign } from "react-feather";
import ActiveCurioers from "../../Components/Common/svg/shippingIcons/activeCurioers";
import ActiveOrdersIcon from "../../Components/Common/svg/shippingIcons/activeOrders";
import AvaliableCurioersIcon from "../../Components/Common/svg/shippingIcons/avaliableCurioers";
import CompanyIcon from "../../Components/Common/svg/shippingIcons/companyicon";
import DollarSignYellow from "../../Components/Common/svg/shippingIcons/dollarSign";
import LocationsIcons from "../../Components/Common/svg/shippingIcons/locations";
import StarsIcon from "../../Components/Common/svg/shippingIcons/startsIcon";
import SuccessShippingIcon from "../../Components/Common/svg/shippingIcons/successShipping";
import UsersIcon from "../../Components/Common/svg/shippingIcons/usersIcon";
import StatusBadge from "../../Components/UI/statusBadge";
import TableActions from "../../Components/UI/table/TableActions";
import { deleteCurios, updateCurios } from "../../MyApi/curior";
import { deleteDelivery, updateDelivery } from "../../MyApi/delivery";
import { deleteShippingPricing, updateShippingPrices } from "../../MyApi/shippingprice";
import { formatPrice } from "../../utils/formatPrice";
import i18next from "i18next";

export const tabs = [
  {
    key: "shippings",
    label: "شركات الشحن",
    permission: "view_delivery_company",
  },
  {
    key: "courier",
    label: "السائقين",
    permission: "view_couier",
  },
  {
    key: "pricing",
    label: "تسعير المناطق",
    permission: "view_shipping_price",
  },
];
export const curiorColumns = [
  {
    label: "اسم السائق",
    render: (row) => (
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <img
          src={row?.avatar} // ← عدّلها حسب اسم الفيلد
          alt={row.name}
          style={{
            width: "65px",
            height: "65px",
            borderRadius: "10px",
            objectFit: "cover",
            border: "1px solid #ddd",
          }}
        />
        <div>
          <div>{row.name}</div>
          <div># {row.id}</div>
        </div>
      </div>
    ),
  },
  { label: "الشركة", accessor: "store.name" },
  { label: "رقم الجوال", accessor: "phone" },
  {
    label: "الحالة",
    render: (row) => <StatusBadge status={row?.status} />,
  },

  { label: "الطلبات", accessor: "total_order" },

  { label: "التقييم", accessor: "avg_rate" },
  { label: "الأرباح", accessor: "total_earning" },

  {
    label: "الإجراءات",
    render: (row) => (
      <TableActions
        show={`${process.env.PUBLIC_URL}/curior/${row.id}`}
        edit={`${process.env.PUBLIC_URL}/curior/edit/${row.id}`}
        deleteFn={deleteCurios}
        id={row.id}
        mutationKey={["deleteCurios"]}
        queryKey={"getCurios"}
        deletePermission={"delete_couier"}
        editPermission={"update_couier"}
        viewPermission={"view_couier"}
        toggleMutationKey={["toggleCurios"]}
        is_active={row.status === "active"}
        toggleFn={(id, status) =>
          updateCurios(
            {
              courier: { status: row.status ==="active" ? "inactive" : "active" },
              _method: "PUT",
              lang: i18next.language,
            },
            id
          )
        }
        togglePermission={"update_couier"}
      />
    ),
  },
];

export const shippinColumns = [
  { label: "الشركة", accessor: "name" },
  // { label: "البريد الإلكتروني", accessor: "email" },
  { label: "رقم الجوال", accessor: "phone" },
  { label: "عدد السائقين", accessor: "total_couriers" },
  { label: "الطلبات", accessor: "total_orders" },
  {
    label: "الإيرادات",
    render: (row) => (
      <div className="text-green">
        {formatPrice(row.currency_factor, row.total_revenue)}
        {row.symbol_currency}
      </div>
    ),
  },
  {
    label: "الحالة",
    render: (row) => (
      <StatusBadge status={row.is_active ? "active" : "inactive"} />
    ),
  },
  {
    label: "الإجراءات",
    render: (row) => (
      <TableActions
        show={`${process.env.PUBLIC_URL}/shipping/${row.id}`}
        edit={`${process.env.PUBLIC_URL}/shipping/edit/${row.id}`}
        is_active={row.is_active}
        editPermission={"update_delivery_company"}
        deletePermission={"delete_delivery_company"}
        viewPermission={"view_delivery_company"}
        deleteFn={deleteDelivery}
        id={row.id}
        queryKey={"getdeliveryData"}
        togglePermission={"update_delivery_company"}
        toggleMutationKey={"toggle_delivery_company"}
        toggleFn={(id, status) =>
          updateDelivery(
            {
              store: { is_active: status },
              _method: "PUT",
              lang: i18next.language,
         
            },
            id,
          )
        }
      />
    ),
  },
];

export const shippingPriceColumns = [
  { label: "اسم المنطقة", accessor: "zone_name" },
  { label: "نوع المركبة", accessor: "vehicle_name" },
  {
    label: "سعر البداية",
    render: (row) => (
      <div>{formatPrice(row.currency_factor, row.base_price)} </div>
    ),
  },
  {
    label: "أقصى سعر",
    render: (row) => (
      <div>{formatPrice(row.currency_factor, row.max_price)}</div>
    ),
  },
  {
    label: "السعر لكل كم",
    render: (row) => (
      <div> {formatPrice(row.currency_factor, row.per_km_price)} </div>
    ),
  },
  {
    label: "أقصى سعر استلام كاش",
    render: (row) => (
      <div> {formatPrice(row.currency_factor, row.max_cod_price)}</div>
    ),
  },
  { label: "تفعيل الدفع كاش", accessor: "enable_cod" },
  {
    label: "حالة المنطقة",
    render: (row) => (
      <StatusBadge status={row.is_active ? "active" : "inactive"} />
    ),
  },
  {
    label: "عدد الطلبات النشطة",
    accessor: "active_orders_count",
  },
  {
    label: "عدد السائقين",
    accessor: "total_couriers_count",
  },
  {
    label: "الإجراءات",
    render: (row) => (
      <TableActions
        edit={`${process.env.PUBLIC_URL}/shipping/store-pricing-zone/edit/${row.id}`}
        editPermission={"update_shipping_price"}
        deletePermission={"delete_shipping_price"}
        deleteFn={deleteShippingPricing}
        id={row.id}
        is_active={row.is_active}
        queryKey={"getShippingpricing"}
        
      />
    ),
  },
];

export const shippingStatsConfig = (deliveyStatics, currency_factor) => [
  {
    title: "نسبة نجاح التوصيل",
    count: deliveyStatics.success_rate,
    color: "#FFCC03",
    icon: <SuccessShippingIcon />,
    bgIcon: "#E6F3EF",
  },
  {
    title: "إجمالي الأرباح",
    count: formatPrice(
      deliveyStatics.currency_factor,
      deliveyStatics.total_revenue,
    ),
    color: "#003726",
    icon: <DollarSign />,
    bgIcon: "#8AC6B4",
  },
  {
    title: "الطلبات المنفذة",
    count: deliveyStatics.executed_orders,
    color: "#616161",
    icon: <ActiveOrdersIcon />,
    bgIcon: "#EBEBEB",
  },
  {
    title: "إجمالي السائقين",
    count: deliveyStatics.total_couriers,
    color: "#FFCC00",
    icon: <UsersIcon />,
    bgIcon: "#fff",
  },
  {
    title: "عدد شركات الشحن",
    count: deliveyStatics.total_delivery_companies,
    color: "#0F2B42",
    icon: <CompanyIcon />,
    bgIcon: "#E7EAEC",
  },
];

export const curiorStatsConfig = (curiorStatics) => [
  {
    title: "السائقين النشطين",
    count: curiorStatics.active_couiers,
    color: "#FFCC03",
    icon: <ActiveCurioers />,
    bgIcon: "#E6F3EF",
  },
  {
    title: "متوسط التقييم",
    count: curiorStatics.average_rate,
    color: "#003726",
    icon: <StarsIcon />,
    bgIcon: "#8AC6B4",
  },
  {
    title: " إجمالي الطلبات",
    count: curiorStatics.total_orders,
    color: "#616161",
    icon: <ActiveOrdersIcon />,
    bgIcon: "#EBEBEB",
  },
  {
    title: "السائقين المتاحين",
    count: curiorStatics.available_couiers,
    color: "#FFCC00",
    icon: <AvaliableCurioersIcon />,
    bgIcon: "#fff",
  },
  {
    title: "عدد السائقين الكلي",
    count: curiorStatics.total_couiers,
    color: "#0F2B42",
    icon: <UsersIcon />,
    bgIcon: "#E7EAEC",
  },
];
export const shippingPricesStatcs = (shippingPricesStatcscounts) => [
  {
    title: "عدد المناطق",
    count: shippingPricesStatcscounts?.total_zones_with_shipping,
    color: "#FFCC03",
    icon: <LocationsIcons />,
    bgIcon: "#E6F3EF",
  },
  {
    title: "الشركات المغطية",
    count: shippingPricesStatcscounts?.total_delivery_companies,
    color: "#003726",
    icon: <CompanyIcon />,
    bgIcon: "#8AC6B4",
  },
  {
    title: "الطلبات الجارية",
    count: shippingPricesStatcscounts?.total_active_orders,
    color: "#616161",
    icon: <ActiveOrdersIcon />,
    bgIcon: "#EBEBEB",
  },
  {
    title: "متوسط التوصيل",
    count: shippingPricesStatcscounts?.average_delivery_price,
    color: "#616161",
    color: "#FFCC00",
    icon: <DollarSignYellow />,
    bgIcon: "#FFFCE9",
  },
  {
    title: "عدد السائقين",
    count: shippingPricesStatcscounts?.total_couriers,
    color: "#0F2B42",
    icon: <UsersIcon />,
    bgIcon: "#E7EAEC",
  },
];
